import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/auth",
    name: "auth",
    component: () => import("../views/AuthView.vue"),
    meta: {
      title: "Inicia sesión | Backoffice - Taqui",
    },
  },
  {
    path: "/resetPass",
    name: "resetPass",
    component: () => import("../views/ResetPassView.vue"),
    meta: {
      title: "Restablece tu contraseña | Backoffice - Taqui",
    },
  },
  {
    path: "/",
    name: "home",
    component: () => import("../views/HomeView.vue"),
    redirect: "/dashboard",
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("../views/DashboardView.vue"),
        meta: {
          title: "Inicio | Backoffice - Taqui",
        },
      },
      {
        path: "/usuarios",
        redirect: "/usuarios/1",
      },
      {
        path: "/usuarios/:page",
        name: "usuarios",
        component: () => import("../views/UsuariosView.vue"),
        meta: {
          title: "Usuarios | Backoffice - Taqui",
        },
      },
      {
        path: "/eventos",
        redirect: "/eventos/1",
      },
      {
        path: "/eventos/:page",
        name: "eventos",
        component: () => import("../views/EventosView.vue"),
        meta: {
          title: "Eventos | Backoffice - Taqui",
        },
      },
      {
        path: "/grupos/:page",
        name: "grupos",
        component: () => import("../views/GruposView.vue"),
        meta: {
          title: "Grupos de eventos | Backoffice - Taqui",
        },
      },
      {
        path: "/evento/:idEvento",
        name: "evento",
        component: () => import("../views/EventoView.vue"),
        meta: {
          title: "Evento | Backoffice - Taqui",
        },
      },
      {
        path: "/localidades/:idEvento",
        name: "localidades",
        component: () => import("../views/LocalidadesView.vue"),
        meta: {
          title: "Localidades | Backoffice - Taqui",
        },
      },
      {
        path: "/mapa/:idEvento",
        name: "mapa",
        component: () => import("../views/MapaView.vue"),
        meta: {
          title: "Mapa de evento | Backoffice - Taqui",
        },
      },
      {
        path: "/mapaTeatro/:idEvento",
        name: "mapaTeatro",
        component: () => import("../views/MapaTeatroView.vue"),
        meta: {
          title: "Mapa de evento | Backoffice - Taqui",
        },
      },
      {
        path: "/lugares",
        redirect: "/lugares/1",
      },
      {
        path: "/lugares/:page",
        name: "lugares",
        component: () => import("../views/LugaresView.vue"),
        meta: {
          title: "Lugares | Backoffice - Taqui",
        },
      },
      {
        path: "/reservas",
        redirect: "/reservas/1",
      },
      {
        path: "/reservas/:page",
        name: "reservas",
        component: () => import("../views/ReservasView.vue"),
        meta: {
          title: "Reservas | Backoffice - Taqui",
        },
      },
      {
        path: "/nuevaReserva",
        name: "nuevaReserva",
        component: () => import("../views/NuevaReservaView.vue"),
        meta: {
          title: "Nueva reserva | Backoffice - Taqui",
        },
      },
      {
        path: "/bloqueos",
        name: "bloqueos",
        component: () => import("../views/BloqueosView.vue"),
        meta: {
          title: "Bloqueos | Backoffice - Taqui",
        },
      },
      {
        path: "/reporteFechaServicio",
        name: "reporteFechaServicio",
        component: () => import("../views/ReporteFechaServicioView.vue"),
        meta: {
          title: "Reportes | Backoffice - Taqui",
        },
      },
      {
        path: "/reportes",
        name: "reportes",
        component: () => import("../views/ReportesView.vue"),
        meta: {
          title: "Reportes | Backoffice - Taqui",
        },
      },
      {
        path: "/reservasUsuarios",
        name: "reservasUsuarios",
        component: () => import("../views/ReservasUsuariosView.vue"),
        meta: {
          title: "Reservas por usuario | Backoffice - Taqui",
        },
      },
      {
        path: "/entregas",
        name: "entregas",
        component: () => import("../views/EntregasView.vue"),
        meta: {
          title: "Entregas | Backoffice - Taqui",
        },
      },
      {
        path: "/ingresos",
        redirect: "/ingresos/1",
      },
      {
        path: "/ingresos/:page",
        name: "ingresos",
        component: () => import("../views/IngresosView.vue"),
        meta: {
          title: "Ingresos | Backoffice - Taqui",
        },
      },
      {
        path: "/clientes/:page",
        name: "clientes",
        component: () => import("../views/ClientesView.vue"),
        meta: {
          title: "Clientes | Backoffice - Taqui",
        },
      },
      {
        path: "/replicas",
        redirect: "/replicas/1",
      },
      {
        path: "/replicas/:page",
        name: "replicas",
        component: () => import("../views/ReplicasView.vue"),
        meta: {
          title: "Réplicas | Backoffice - Taqui",
        },
      },
      {
        path: "/codigos",
        redirect: "/codigos/1",
      },
      {
        path: "/codigos/:page",
        name: "codigos",
        component: () => import("../views/CodigosView.vue"),
        meta: {
          title: "Códigos de descuento y promotores | Backoffice - Taqui",
        },
      },
      {
        path: "/abonos",
        redirect: "/abonos/1",
      },
      {
        path: "/abonos/:page",
        name: "abonos",
        component: () => import("../views/AbonosView.vue"),
        meta: {
          title: "Reservas de abonos | Backoffice - Taqui",
        },
      },
      {
        path: "/reportesAbonos",
        name: "reportesAbonos",
        component: () => import("../views/ReportesAbonosView.vue"),
        meta: {
          title: "Reportes de abonos | Backoffice - Taqui",
        },
      },
      {
        path: "/nuevaReservaAbono",
        name: "nuevaReservaAbono",
        component: () => import("../views/NuevaReservaAbonosView.vue"),
        meta: {
          title: "Nueva reserva de abono | Backoffice - Taqui",
        },
      },
      {
        path: "/reportesAbonos",
        name: "reportesAbonos",
        component: () => import("../views/ReportesAbonosView.vue"),
        meta: {
          title: "Reportes de abonos | Backoffice - Taqui",
        },
      },
      {
        path: "/codigosImportados/:idEvento",
        name: "codigosImportados",
        component: () => import("../views/CodigosImportadosView.vue"),
        meta: {
          title: "Códigos de eventos importados | Backoffice - Taqui",
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to) => {
  document.title = to.meta?.title ?? "Backoffice - Taqui";
});

export default router;
